import React from 'react';
import { Button } from "react-bootstrap";
import { format } from 'date-fns';
import { Add, FilterSquare, UserCirlceAdd, UserOctagon, ProfileCircle } from 'iconsax-react';
import TabellaLista from '../../../../components/Tabella/TabellaLista';
export const JuniorTable = () => {

	const data_column = [

		{
			Header: 'Prodotto',
			accessor: 'lista_prodotto',
		},
		{
			Header: 'Nome utente',
			accessor: 'lista_utente',
			Cell: ({ value }) => {
				return (
					<Button variant="dark light" size="xs" >
						<span className="me-2"><ProfileCircle size="24" variant="Bulk" /></span>
						{value}
					</Button>
				)
			},
			disableFilters: true,
		},
        {
			Header: 'Data',
			accessor: 'lista_data',
			disableGlobalFilter: true,
		},
        {
			Header: 'Ora',
			accessor: 'lista_ora',
			disableGlobalFilter: true,
		},
	];
	const data_json = [
		{
			"id": 1,
			"lista_prodotto": "Affitto campo da tennis",
			"lista_utente": "Giorgio Giorgi",
			"lista_data": "28 maggio 2024",
			"lista_ora": "11:;30",
		},
		{
			"id": 2,
			"lista_prodotto": "Lezione di tennis",
			"lista_utente": "Maria Mercurio",
			"lista_data": "30 maggio 2024",
			"lista_ora": "17:;30",
		}
	];

	return (
		<>
			<TabellaLista
				pageList={true}
				cardTitle={'Lista di attesa'}
				hasSearch={true}
				searchPlaceholder={'Cerca per prodotto o utente'}
				hasFilter={false}
				hasAddMore={false}
				data_column={data_column}
				data_json={data_json}
			/>
		</>
	)

}
export default JuniorTable;